<template>
  <!-- 我的简历 -->
  <div class="purse-body">
    <!-- 标题 -->
    <p class="title-Individual-center">
      个人中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">我的简历</span>
    </p>
    <!-- 内容主体 -->
    <div class="Content-subject" id="pdfDom">
      <!-- 打印 - 下载 -->
      <div class="headFeature">
        <div class="Download-icon firm-clickable" @click="getPdf()"></div>
        <p class="firm-clickable" @click="getPdf()">下载</p>
        <div class="print-icon firm-clickable" @click="goPrint"></div>
        <p class="firm-clickable" @click="goPrint">打印</p>
      </div>
      <div ref="print">
        <!-- 用户信息 -->
        <div class="User">
          <!-- 使用用户信息组件 -->
          <User
            :data="AllData"
            :childYears="childYears"
            @handelSubmit="handelSubmit"
          ></User>
        </div>
        <!-- 求职状态 - 标题栏 -->
        <div class="Title">
          <div class="Title-name">求职状态</div>
          <p class="required">必填</p>
          <div class="Title-EDITOR firm-clickable" @click="handelClickEDITOR(1)"></div>
        </div>
        <!-- 求职状态内容 -->
        <div class="ApplyForAJob">
          <ApplyForAJob
            :data="AllData.jobStatus"
            :ApplyForAJob="EditAddObj.ApplyForAJob"
            @handelUnEdit="handelUnEdit"
            @handelSubmitEdit="handelSubmitEdit"
          ></ApplyForAJob>
        </div>
        <!-- 求职意向 - 标题栏 -->
        <div class="Title">
          <div class="Title-name">求职意向</div>
          <p class="required">必填</p>
        </div>
        <!-- 求职意向内容 -->
        <div>
          <Intention
            :data="IntentionData"
            @handelUnEdit="handelUnEdit"
            @handelSubmitEdit="handelSubmitEdit"
          ></Intention>
        </div>
        <!-- 自我评价 - 标题栏 -->
        <div class="Title">
          <div class="Title-name">自我评价</div>
          <div class="Title-EDITOR firm-clickable" @click="handelClickEDITOR(3)"></div>
        </div>
        <!-- 自我评价内容 -->
        <div>
          <Evaluate
            :data="selfEval"
            :ApplyForAJob="EditAddObj.Evaluate"
            @handelUnEdit="handelUnEdit"
            @handelSubmitEdit="handelSubmitEdit"
            @handelClickEDITOR="handelClickEDITOR"
          ></Evaluate>
        </div>
        <!-- 工作经历 - 标题栏 -->
        <div class="Title">
          <div class="Title-name">工作经历</div>
          <p class="required">必填</p>
        </div>
        <!-- 工作经历内容 -->
        <div>
          <PGoThrough
            :data="ProfessionalData"
            :ApplyForAJob="EditAddObj.Professional"
            @handelUnEdit="handelUnEdit"
            @handelSubmitEdit="handelSubmitEdit"
          ></PGoThrough>
        </div>
        <!-- 项目经历 - 标题栏 -->
        <div class="Title">
          <div class="Title-name">项目经历</div>
        </div>
        <!-- 项目经历内容 -->
        <div>
          <ItemExp
            :data="ItemBookData"
            :ApplyForAJob="EditAddObj.ItemBook"
            @handelUnEdit="handelUnEdit"
            @handelSubmitEdit="handelSubmitEdit"
            @handelClickEDITOR="handelClickEDITOR"
          ></ItemExp>
        </div>
        <!-- 教育经历 - 标题栏 -->
        <div class="Title">
          <div class="Title-name">教育经历</div>
          <p class="required">必填</p>
        </div>
        <!-- 教育经历内容 -->
        <div>
          <Education
            :data="EducationData"
            :ApplyForAJob="EditAddObj.Education"
            @handelUnEdit="handelUnEdit"
            @handelSubmitEdit="handelSubmitEdit"
          ></Education>
        </div>
        <!-- 证书 -->
        <div class="Title">
          <div class="Title-name">证书</div>
        </div>
        <div>
          <Certificate
            :data="CertificateData"
            :ApplyForAJob="EditAddObj.Certificate"
            @handelUnEdit="handelUnEdit"
            @handelSubmitEdit="handelSubmitEdit"
          ></Certificate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import printJS from "print-js";
import html2canvas from "html2canvas";
// 引入接口
import {
  getUserResumeInfo, // 个人中心-我的简历-查询用户简历信息（基本信息+求职信息）
} from "../../../../../assets/api/CenterJane";
// 个人信息
import User from "./components/user.vue";
// 求职状态
import ApplyForAJob from "./components/ApplyForAJob.vue";
// 求职意向
import Intention from "./components/Intention.vue";
// 自我评价
import Evaluate from "./components/Evaluate.vue";
// 工作经历
import PGoThrough from "./components/PGoThrough.vue";
// 项目经历
import ItemExp from "./components/ItemExp.vue";
// 教育经历
import Education from "./components/Education.vue";
// 证书
import Certificate from "./components/Certificate.vue";
export default {
  data() {
    return {
      EditAddObj: {
        ApplyForAJob: 1, //求职状态 1正常显示 2开始编辑
        Intention: 1, // 求职意向  1正常显示  2开始编辑/添加
        Evaluate: 1, // 自我评价  1正常显示  2开始编辑
        Professional: 1, // 工作经历  1正常显示 2开始编辑
        ItemBook: 1, // 项目经历 1正常显示 2开始编辑
        Education: 1, // 教育经历  1正常显示 2开始编辑
        Certificate: 1, // 证书  1正常显示 2开始编辑
      }, //各个模块编辑或正常显示
      IntentionData: [], //求职意向数组
      EvaluateData: [
        {
          data: "",
        },
      ], // 自我评价数据
      selfEval: "", //自我评价数据
      ProfessionalData: [], //工作经历数据
      ItemBookData: [], //项目经历数据
      EducationData: [], //教育经历数据
      CertificateData: [], //证书数据
      AllData: {}, // 个人全部数据
      childYears: "",
      htmlTitle: "pdf文件名",
    };
  },
  // 引入的组件
  components: {
    User,
    ApplyForAJob,
    Intention,
    Evaluate,
    PGoThrough,
    ItemExp,
    Education,
    Certificate,
  },
  created() {
    this.postGetAllUserInfo();
  },
  methods: {
    goPrint() {
      this.isPrint = true;
      html2canvas(this.$refs.print, {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 4,
        scale: 4,
      }).then((canvas) => {
        const url = canvas.toDataURL();
        printJS({
          printable: url, // 要打印的id
          type: "image",
          style: "@page{size:auto;margin: 0cm 2cm 0cm 2cm;}", //去除页眉页脚
        });
        this.isPrint = false;
      });
    },
    // 个人基本信息修改成功刷新数据
    handelSubmit() {
      this.postGetAllUserInfo();
    },
    // 获取个人全部信息
    async postGetAllUserInfo() {
      const res = await getUserResumeInfo({
        data: this.$store.getters.getUser.id,
      });
      if (!res || !res.data) return;
      this.AllData = res.data;
      // // 求职意向数据赋值
      this.IntentionData =
        res.data.userJobIntentionList != null
          ? res.data.userJobIntentionList
          : [];
      // // 自我评价
      this.selfEval = res.data.selfEval != null ? res.data.selfEval : "";
      // // 工作经历
      this.ProfessionalData =
        res.data.userWorkExpList != null ? res.data.userWorkExpList : [];
      // // 项目经历
      this.ItemBookData =
        res.data.userProjectExpList != null ? res.data.userProjectExpList : [];
      // 教育经历
      this.EducationData =
        res.data.userEducationExpList != null
          ? res.data.userEducationExpList
          : [];
      // // 证书
      this.CertificateData =
        res.data.userCertificateList != null
          ? res.data.userCertificateList
          : [];
      // 拿到出生年月日转为时间戳在通过封装好的计算年龄函数得到年龄
      let date = new Date(this.AllData.birthday);
      this.childYears = this.$tool.compute(date.getTime());
      // 得到年龄存入本地存储后续使用
      // localStorage.setItem("years", years);
    },
    // 点击编辑函数，num=1 点击求职状态编辑  2求职意向点击添加 3自我评价  4工作经历  5项目经历 6教育经历 7证书
    handelClickEDITOR(num) {
      if (num == 1) {
        // 点击编辑/添加打开求职状态 编辑栏
        this.EditAddObj.ApplyForAJob = 2;
      } else if (num == 2) {
        // 点击编辑/添加打开求职意向 编辑栏
        this.EditAddObj.Intention = 2;
      } else if (num == 3) {
        // 点击编辑/添加打开自我评价 编辑栏
        this.EditAddObj.Evaluate = 2;
      } else if (num == 4) {
        // 点击编辑/添加打工作经历 编辑栏
        this.EditAddObj.Professional = 2;
      } else if (num == 5) {
        // 点击编辑/添加打开项目经历 编辑栏
        this.EditAddObj.ItemBook = 2;
      } else if (num == 6) {
        // 点击编辑/添加打开教育经历 编辑栏
        this.EditAddObj.Education = 2;
      } else if (num == 7) {
        // 点击编辑/添加打开证书 编辑栏
        this.EditAddObj.Certificate = 2;
      }
    },
    // 编辑取消  1.求职状态编辑取消  2求职意向 3自我评价  4工作经历  5项目经历 6教育经历 7证书
    handelUnEdit(val) {
      if (val == 1) {
        // 关闭求职状态 编辑栏
        this.EditAddObj.ApplyForAJob = 1;
      } else if (val == 2) {
        // 关闭求职意向 编辑栏
        this.EditAddObj.Intention = 1;
      } else if (val == 3) {
        // 关闭自我评价 编辑栏
        this.EditAddObj.Evaluate = 1;
      } else if (val == 4) {
        // 关闭工作经历 编辑栏
        this.EditAddObj.Professional = 1;
      } else if (val == 5) {
        // 关闭项目经历 编辑栏
        this.EditAddObj.ItemBook = 1;
      } else if (val == 6) {
        // 关闭教育经历 编辑栏
        this.EditAddObj.Education = 1;
      } else if (val == 7) {
        // 关闭证书 编辑栏
        this.EditAddObj.Certificate = 1;
      }
    },
    // 编辑确认 1.求职状态编辑确认  2求职意向 3自我评价  4工作经历  5项目经历 6教育经历 7证书
    handelSubmitEdit(val) {
      if (val == 1) {
        // 提交并关闭求职状态 编辑栏
        this.EditAddObj.ApplyForAJob = 1;
      } else if (val == 2) {
        // 提交并关闭求职意向 编辑栏
        this.EditAddObj.Intention = 1;
      } else if (val == 3) {
        // 提交并关闭自我评价 编辑栏
        this.EditAddObj.Evaluate = 1;
      } else if (val == 4) {
        // 提交并关闭工作经历 编辑栏
        this.EditAddObj.Professional = 1;
      } else if (val == 5) {
        // 提交并关闭项目经历 编辑栏
        this.EditAddObj.ItemBook = 1;
      } else if (val == 6) {
        // 提交并关闭教育经历 编辑栏
        this.EditAddObj.Education = 1;
      } else if (val == 7) {
        // 提交并关闭证书 编辑栏
        this.EditAddObj.Certificate = 1;
      }
      this.postGetAllUserInfo();
    },
  },
};
</script>

<style scoped lang="less">
// 最外层div
.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // 内容主体div
  .Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    margin-top: 13px;
    padding: 30px;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    // page-break-inside: avoid;
    // border: 1px solid gold;
    // 头部打印下载
    .headFeature {
      width: 100%;
      height: 20px;
      line-height: 25px;
      display: flex;
      cursor: pointer;
      // 下载icon样式
      .Download-icon {
        width: 20px;
        height: 20px;
        background-image: url("../../../../../assets/imgs/xiazai@3x.svg");
        background-size: 100% 100%;
      }
      // 打印icon样式
      .print-icon {
        width: 20px;
        height: 20px;
        background-image: url("../../../../../assets/imgs/dayin@3x.svg");
        background-size: 100% 100%;
      }
      // 文字style
      p {
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        margin-left: 10px;
        margin-right: 40px;
        cursor: pointer;
      }
    }
    // 用户信息
    .User {
      width: 100%;
      min-height: 100px;
      margin-top: 20px;
      display: flex;
    }
    // 标题
    .Title {
      width: 100%;
      height: 25px;
      line-height: 25px;
      display: flex;
      margin-top: 40px;
      margin-bottom: 25px;
      // 标题名
      .Title-name {
        text-align: center;
        min-width: 80px;
        height: 25px;
        line-height: 23px;
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #333333;
        font-weight: 400;
        margin-right: 15px;
        background-image: url("../../../../../assets/imgs/zhuangshi@3x.svg");
        background-repeat: no-repeat;
        background-size: 100% 40%;
        background-position: 0px 14px;
      }
      // 是否必填
      .required {
        font-size: 12px;
        color: #666666;
        font-weight: 400;
      }
      // 编辑icon样式
      .Title-EDITOR {
        width: 18px;
        height: 18px;
        background-image: url("../../../../../assets/imgs/bianji@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-left: 30px;
      }
      // 添加icon样式
      .Title-Add {
        width: 18px;
        height: 18px;
        background-image: url("../../../../../assets/imgs/tianjia@2x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-left: 30px;
        margin-right: 5px;
      }
      // 添加icon后的文字样式
      .Title-p {
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      }
    }
  }
}
</style>
